// src/components/BlockedUsersDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemAvatar, Avatar, ListItemText, Button, Box, CircularProgress, Typography, DialogActions } from '@mui/material';
import { useBlockedUsers } from '../hooks/useBlockedUsers';
import { auth, db } from '../config/firebase';
import { doc, updateDoc, arrayRemove } from 'firebase/firestore';

const BlockedUsersDialog = ({ open, onClose }) => {
  const { blockedUsers, loading } = useBlockedUsers();
  const currentUser = auth.currentUser;

  const handleUnblock = async (uidToUnblock) => {
    if (!currentUser) return;
    const currentUserRef = doc(db, 'users', currentUser.uid);
    try {
      // Simply remove the user's UID from the 'blockedUsers' array
      await updateDoc(currentUserRef, {
        blockedUsers: arrayRemove(uidToUnblock)
      });
    } catch (err) {
      console.error("Error unblocking user:", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Manage Blocked Users</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>
        ) : blockedUsers.length === 0 ? (
          <Typography sx={{ p: 4, textAlign: 'center' }} color="text.secondary">You haven't blocked any users.</Typography>
        ) : (
          <List>
            {blockedUsers.map(user => (
              <ListItem key={user.uid} secondaryAction={
                <Button variant="outlined" size="small" onClick={() => handleUnblock(user.uid)}>
                  Unblock
                </Button>
              }>
                <ListItemAvatar><Avatar src={user.photoURL} /></ListItemAvatar>
                <ListItemText primary={user.displayName} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
          <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockedUsersDialog;